import { PaymentProductEntityModel } from "src/store/models/entity/payment/product/entity";
import { PaymentProductHelperModel } from "src/store/models/entity/payment/product/helper";

export const encooPaymentProductModels = {
  entity: PaymentProductEntityModel,
  helper: PaymentProductHelperModel,
};
